import * as React from "react";
import ReactTable from "react-table";
import {Afiliacion, FiltroRecepcionDocumental} from "../../modelo/Documento";
import {EstadoDocumento} from "../../modelo/EstadosDocumento";
import ModalRecepcion from "./ModalRecepcion";
import ModalAnular from "./ModalAnular";
import ModalMensajeAprobacion from "./ModalMensajeAprobacion";
import ModalMensajeEnProceso from "./ModalMensajeEnProceso";
import ModalMensajeRechazo from "./ModalMensajeRechazo";
import ModalMensajeBorrado from "./ModalMensajeBorrado";


export default class
TablaRecepcion extends React.Component<TablaRecepcionProps> {

    columns = [{
        Header: "Identificación",
        accessor: "afiliado.identificacion",
    }, {
        Header: "Nombre Legal",
        accessor: "afiliado.nombreLegal",
    }, {
        Header: "Nombre Comercial",
        accessor: "afiliado.nombreComercial",
    }, {
        Header: "Estado",
        accessor: "estado"
    }, {
        Header: "Tipo Cliente",
        accessor: "tipoCliente.nombre",
    }, {
        Header: "Recibir",
        accessor: "estado",
        Cell: props => (
            <div className={"text-center"}>{
                props.original.estado === EstadoDocumento.pendiente || props.original.estado === EstadoDocumento.rechazado ?
                    <ModalRecepcion dni={props.original.afiliado.identificacion}
                                    tipoCliente={props.original.tipoCliente}/> :
                props.original.estado === EstadoDocumento.anulado ? 
                    <ModalAnular dni={props.original.afiliado.identificacion}
                                    tipoCliente={props.original.tipoCliente}/> :
                props.original.estado === EstadoDocumento.aprobado ? 
                    <ModalMensajeAprobacion/>:
                props.original.estado === EstadoDocumento.recibidoVerificacion ? 
                    <ModalMensajeEnProceso tipoCliente={props.original.tipoCliente.nombre}/> :
                props.original.estado === EstadoDocumento.enProceso ? 
                    <ModalMensajeEnProceso tipoCliente={props.original.tipoCliente.nombre}/> :
                props.original.estado === EstadoDocumento.rechazado ? 
                    <ModalMensajeRechazo/>:
                props.original.estado === EstadoDocumento.borrado ? 
                    <ModalMensajeBorrado/>:
                                    "N/A"
            }</div>
        ),
    }];

    render() {
        const {afiliaciones, paginas, tamanoPagina, paginaActual} = this.props;
        let numRegistros = 0;

        if (afiliaciones.length < tamanoPagina) {
            numRegistros = afiliaciones.length;
        } else {
            numRegistros = tamanoPagina;
        }
        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{afiliaciones.length}</span> Afiliaciones encontrados
                    </h2>
                </div>
                <ReactTable data={afiliaciones}
                            columns={this.columns}
                            manual
                            defaultPageSize={numRegistros}
                            pageSizeOptions={this.calcularOpciones(numRegistros)}
                            page={paginaActual}
                            sortable={false}
                            resizable={false}
                            previousText={"Anterior"}
                            nextText={"Siguiente"}
                            loadingText={"Cargando..."}
                            noDataText={"No se ha encontrado información."}
                            pageText={"Página"}
                            ofText={"de"}
                            rowsText={""}
                            className={"-highlight -striped"}
                            pages={paginas}
                            onPageChange={(pageIndex) => {
                                this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                            }}
                            onPageSizeChange={(pageSize, pageIndex) => {
                                this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                            }}
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        const filtroDocumento: FiltroRecepcionDocumental = {
            dni: this.props.filtroDocumento.dni,
            tipoCliente: this.props.filtroDocumento.tipoCliente,
            tamanoPagina: pageSize ? pageSize : tamanoPagina,
            paginaActual: pageIndex,
        };
        this.props.consultaPaginada(filtroDocumento);
    }

    calcularOpciones(tamanoPagina : number) {
       const arreglo = [10, 20, 25, 50, 100];
       const elemento = arreglo.find(valor => valor === tamanoPagina);
       if( elemento ) {
           return arreglo;
       } else {
        return [...arreglo,tamanoPagina].sort( (a, b) => {return a-b;} );
       }
    }

}

interface TablaRecepcionProps {
    afiliaciones: Array<Afiliacion>
    filtroDocumento: FiltroRecepcionDocumental,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    consultaPaginada?: (filtroDocumento: FiltroRecepcionDocumental) => void
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/recepcion/TablaRecepcion.tsx